var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-map-tabs" },
    [
      _c(
        "div",
        {
          staticClass: "c-map-tabs__list",
          attrs: { role: "tablist", "aria-label": "Details" }
        },
        _vm._l(_vm.tabs, function(tab, i) {
          return _c(
            "button",
            {
              key: i,
              ref: "tab",
              refInFor: true,
              staticClass: "c-map-tabs__button",
              class: { "is-active": _vm.activeIndex === i },
              attrs: {
                "aria-controls": tab.panelId,
                "aria-selected": tab.selected,
                id: tab.tabId,
                tabindex: tab.tabIndex,
                role: "tab"
              },
              on: {
                click: function($event) {
                  return _vm.selectTab(i)
                },
                keyup: function($event) {
                  return _vm.keyHashLookup($event.key, i)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(tab.title) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f09866a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f09866a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/layered-map/MapTabs.vue
// module id = 666
// module chunks = 0